import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { LookupDataState } from '../../store/global/lookup-data/lookup-data.reducer';
import { APP_CONFIG } from '../app-config/app-config.token';
import { AppConfig } from '../app-config/app.config';

@Injectable({
  providedIn: 'root',
})
export class LookupDataService {
  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private http: HttpClient
  ) {}

  /**
   * Returns all lookup data.
   * This should only be call once! from the resolver.
   * Why? Because this caches the whole response with
   * RXJS shareReplay operator.
   * @returns lookup fields object
   */
  getLookupData(hasCustomFields = false): Observable<LookupDataState> {
    return this.http.get<LookupDataState>(
      `${this.appConfig.apiBaseURL}/lookups`,
      {
        params: hasCustomFields
          ? new HttpParams().set(
              'fields',
              'siteStatus,lakes,counties,states,paymentDetailTypes,permitTypeActivities,documentTypes'
            )
          : undefined,
      }
    );
  }
}
